export default __webpack_public_path__ + "static/leva-incastro-bq-2-44c54ce761e99ef1dea84049212cbd1a.jpg";